export const selectAllTurns = state => state.turns.turns
export const selectTotalTurns = state => state.turns.total
export const selectTurn = state => state.turns.turn
export const selectDetailsMultiple = state => state.turns.turns_detail
export const selectTurnSegmentation = state => state.turns.segmentation
